import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div className="py-16 bg-cream min-h-screen">
      <div className="container mx-auto px-4">
        <ContactForm />
      </div>
    </div>
  );
};

export default Contact;